import { FCA_PAYER, PayerUserType } from "constants/payer";
import { useRoleBasedView } from "hooks/useRoleBasedView";

export const useCanMakePayment = (payerUserType?: PayerUserType): boolean => {
  const { isCustomer, isInkleSuperAdmin } = useRoleBasedView();

  return Boolean(
    isCustomer || isInkleSuperAdmin || payerUserType === FCA_PAYER
  );
};
